<script>
  import { format } from 'svelte-i18n';
  import { Col, Row } from '@sveltestrap/sveltestrap';

  import { BizCardItem } from '@client/pages/bizcards/components';

  export let assignments = [];
  export let selected = null;
</script>

{#if !assignments.length}
  <p class="text-muted">{$format('label.NO_RESULTS')}</p>
{:else}
  <div class="scrollable mt-2">
    <Row noGutters>
      {#each assignments as assignment (assignment.name)}
        <Col sm={4} md={3} class="mb-3">
          <button
            class="bizcard-option p-2 w-100 text-center"
            class:active={selected === assignment.name}
            on:click={() => (selected = assignment.name)}
          >
            <BizCardItem rulename={assignment.name} />
            <small class="text-muted">{assignment.userCount} {$format('label.BIZCARD.ASSIGN.USERS_LABEL')}</small>
          </button>
        </Col>
      {/each}
    </Row>
  </div>
{/if}

<style>
  .bizcard-option {
    background: none;
    border: 2px solid transparent;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: border-color 0.15s;
  }

  .bizcard-option:hover {
    border-color: var(--color-gray-400);
  }

  .bizcard-option.active {
    border-color: var(--bs-primary);
  }

  .scrollable {
    max-height: 40vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>
